var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgIcoFilter = function SvgIcoFilter(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    fill: "none",
    viewBox: "0 0 24 24"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    d: "M20.021 3H3.98a2.104 2.104 0 0 0-1.557 3.518l6.953 7.646v7.211a.75.75 0 0 0 1.219.585L12 20.835l2.344-1.875a.75.75 0 0 0 .281-.585v-4.211l6.953-7.646A2.104 2.104 0 0 0 20.02 3"
  })));
};
export default SvgIcoFilter;